<template lang="pug">
  main.main
    home-banner
    home-advantages
    home-features
    home-characteristics
    home-details
    section.big-link.wrapper-p
      a.clr-d-blue.t-tdn(
        href=`#`
        @click.prevent.stop="modalOpen"
      ) Хочу протестировать
    home-feedback
</template>

<script>
import HomeBanner from '@/components/Banner'
import HomeAdvantages from '@/components/Advantages'
import HomeFeatures from '@/components/Features'
import HomeCharacteristics from '@/components/Characteristics'
import HomeDetails from '@/components/Details'
import HomeFeedback from '@/components/Feedback'

export default {
  data () {
    return {
    }
  },
  methods: {
    modalOpen () {
      this.$store.dispatch(`showModal`, {
        title: `Тестирование`,
        visible: true
      })
    }
  },
  components: {
    HomeBanner,
    HomeAdvantages,
    HomeFeatures,
    HomeCharacteristics,
    HomeDetails,
    HomeFeedback
  }
}
</script>

<style lang="scss" scoped>
  .main {
    display: flex;
    flex-direction: column;
  }

  .big-link {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10.6vw;
    padding-bottom: 13.91vw;

    a {
      padding-bottom: 1.5rem;
      font-size: 3.5rem;
      border-bottom: 1px solid $d-blue;
      transition: $trs;

      &:hover {
        opacity: 0.8;
      }
    }

    @include respond-max(tablet) {
      padding-top: 4rem;
      padding-bottom: 4rem;

      a {
        font-size: 2rem;
      }
    }
  }
</style>
